<script>
export default {
  name: "DidoCodeHightlightingJs",
};
</script>

<script setup>
import hljs from "highlight.js/lib/core";
import javascript from "highlight.js/lib/languages/javascript";
import hljsVuePlugin from "@highlightjs/vue-plugin";

hljs.registerLanguage("javascript", javascript);
const HighlightJs = hljsVuePlugin.component;

// define Props
const props = defineProps({
  code: { type: String, required: true },
});
</script>

<template>
  <!-- Highlighting code -->
  <HighlightJs language="javascript" :code="props.code" />
</template>
